import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f8e34f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_h" }, null, -1))
const _hoisted_3 = { class: "details_dj" }
const _hoisted_4 = { class: "details_dj_title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_x" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产出信息", -1))
const _hoisted_7 = { class: "details_num" }
const _hoisted_8 = { class: "details_num_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报工类型", -1))
const _hoisted_10 = {
  key: 0,
  class: "green"
}
const _hoisted_11 = {
  key: 1,
  class: "yellow"
}
const _hoisted_12 = {
  key: 2,
  class: "red"
}
const _hoisted_13 = {
  key: 3,
  class: "black"
}
const _hoisted_14 = { class: "details_num_item" }
const _hoisted_15 = { class: "details_num_item_sr" }
const _hoisted_16 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_zw" }, null, -1))

import { ref, onMounted, nextTick, watch } from 'vue'
    import { Toast } from 'vant'
    import { REGULAR } from '@/utils/utils'
    import { Attribute } from '@/enum'
    import { createProduce, getBarcodeContent, queryById, toolingQueryById } from '@/apis/WorkOrderAPI'
    import { useRouter, useRoute } from "vue-router"
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()
    let total = ref<number>(0)
    const route = useRoute()

    const info: any = ref({})

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 产出数据
    let produceData: any = ref([])

    // 失去焦点验证整数小数
    const changeNumber = (num: any, index: number): void => {
        if (info.value.umodel.attributeData === 0 && num !== '') {  // 整数
            if(!REGULAR.positiveInteger.test(num)) {
                Toast({ message: '只能输入正整数' })
                produceData.value[index].num = ''
            }
        } else if (info.value.umodel.attributeData === 1 && num !== '') {  // 小数（只支持四位小数）
            if(!REGULAR.number.test(num)) {
                Toast({ message: '只能输入正整数或小数（最多四位）' })
                produceData.value[index].num = ''
            }
        }
    }

    // 查询工单详情
    const queryByIds = () => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    // 根据id查询工装器具详情
    const toolingQueryByIds = (id: any) => {
        toolingQueryById({ id }).then(res => {
            if (res.code === 200) {
                let isOpen = true
                produceData.value.forEach((item: any) => {
                    if (item.id === res.data[0].id) {
                        isOpen = false
                    }
                })
                if (isOpen) {
                    produceData.value.push({ id: res.data[0].id, code: res.data[0].code, total: res.data[0].num, num: produceData.value.length === 0 ? res.data[0].num : produceData.value[produceData.value.length - 1].num, type: res.data[0].smodelCode, smodelLabel: res.data[0].smodelLabel, dw: res.data[0].umodelName })
                } else {
                    Toast({ message: '工装已存在', duration: 2000 })
                }
            }
        })
    }

    // 删除产出信息
    const dele = (index: number) => {
        if (produceData.value.length === 1) {
            Toast({
                message: '至少需要投一个篮筐',
                duration: 2000
            })
            return
        }
        produceData.value.splice(index, 1)
    }

    // 打开扫码弹框
    const continueScanning = () => {
        openCode.value = true
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        getBarcodeContent({
            barcode: data[0]
        }).then(res => {
            if (res.code === 200) {
                if (res.data.barcodeType === 4) {
                    toolingQueryByIds(res.data.id)
                } else {
                    Toast({
                        message: '请扫描正确的篮筐码',
                        duration: 2000
                    })
                }
            }
        })
        nextTick(() => {
            openCode.value = false
        })
    }

    // 提交产出
    const submit = () => {
        let isOpen: any = true
        produceData.value.forEach((item: any) => {
            if (item.num === '') {
                isOpen = false
            }
        })
        if (isOpen) {
            let recordList: any = []
            produceData.value.forEach((item: any) => {
                recordList.push({ applianceId: item.id, num: item.num })
            })
            createProduce({
                id: route.query.id,
                recordList: recordList
            }).then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '产出成功', duration: 2000, forbidClick: true })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
        } else {
            Toast.fail({ message: '请完善产出信息' })
        }
    }

    watch(() => produceData.value, (news) => {
        total.value = 0
        news.forEach((element: any) => {
            total.value = total.value + Number(element.num)
        })
    }, { deep: true })

    onMounted(() => {
        queryByIds()
        toolingQueryByIds(route.query.gzId)
    })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: info.value }, null, 8, ["info"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_unref(total)), 1),
          (info.value.umodel)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(info.value.umodel.name), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(produceData), (item, index) => {
      return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
        right: _withCtx(() => [
          _createVNode(_component_van_button, {
            style: {"height":"100%"},
            square: "",
            type: "danger",
            text: "删除",
            onClick: ($event: any) => (dele(index))
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (item.smodelLabel === _unref(Attribute).HG)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.type), 1))
                : (item.smodelLabel === _unref(Attribute).BL)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.type), 1))
                  : (item.smodelLabel === _unref(Attribute).BF)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.type), 1))
                    : (item.smodelLabel === _unref(Attribute).HH)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.type), 1))
                      : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(item.code), 1),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                  onBlur: ($event: any) => (changeNumber(item.num, index)),
                  type: "text"
                }, null, 40, _hoisted_16), [
                  [_vModelText, item.num]
                ]),
                (info.value.umodel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(info.value.umodel.name), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _hoisted_18,
    _createElementVNode("div", { class: "details_footer" }, [
      _createElementVNode("div", {
        class: "details_footer_buttona",
        onClick: continueScanning
      }, "继续扫码"),
      _createElementVNode("div", {
        class: "details_footer_buttonb",
        onClick: submit
      }, "提交")
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})